import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/app-store-optimization/cta-banner.webp";

function SubBanner() {
  return (
    <section
      className="streamline_cloud blockchain_future overflow-x-hidden"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={7} lg={6} xl={5} xxl={5}>
            <h2>
              Need a professional <span>Shopify</span> website?
            </h2>
            <p>
              With years of experience and hundreds of successful eCommerce
              projects, we excel in driving online sales growth.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Get a Free Quote!
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default SubBanner;
